import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router';
import { Database } from 'lucide-react';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
import { TabBar } from './TabBar';
import { CommandPalette } from './CommandPalette';
import { DrillPanel } from '../components/drill';
import { useUi } from '../stores/ui';
import { dataMode } from '../api/hd';

export function Shell() {
  const collapsed = useUi((s) => s.sidebarCollapsed);
  const closeDrill = useUi((s) => s.closeDrill);
  const [navOpen, setNavOpen] = useState(false);
  const { pathname } = useLocation();
  useEffect(() => {
    setNavOpen(false);
    closeDrill();
    window.scrollTo(0, 0);
  }, [pathname, closeDrill]);
  return (
    <div className={`shell${collapsed ? ' collapsed' : ''}`}>
      <Sidebar open={navOpen} onNavigate={() => setNavOpen(false)} />
      {navOpen && <div className="sheet-backdrop" style={{ zIndex: 84 }} onClick={() => setNavOpen(false)} />}
      <div className="main">
        <TopBar onMenu={() => setNavOpen(true)} />
        <main className="content" id="main">
          <div className="data-note">
            <Database size={14} />
            <span>
              Actuals from SAP Business One · 25 Jun – 23 Sep 2026 · Plan, quotas and projections are illustrative
              {dataMode === 'fixture' ? ' · Sample data (fixture)' : ''}
            </span>
          </div>
          <Outlet />
        </main>
      </div>
      <TabBar onMore={() => setNavOpen(true)} />
      <DrillPanel />
      <CommandPalette />
    </div>
  );
}
